const scopes = ["email", "name", "address", "phoneNumber", "birthDate"];

export default scopes;
